module.exports = __webpack_public_path__ + "static/media/hero.d8b40949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/cambridge-student-accommodation/hero.jpg
// module id = 54
// module chunks = 0